
/* Aansluiting van de pagina op de header, lokaal (nagebouwde header) en op Shopify (echte header uit het thema). Draait voor app.js.
   - --hdr: de gemeten onderkant van de header (ResizeObserver). Alles wat onder de header begint (kolommen, categorieen,
     productpagina, overlays, Clean-balken) rekent met --hdr, dus een andere hoogte (aankondiging, gsm, uitklappen) schuift alles mee.
   - categoriechips scrollen met pijltjes, "Jouw feed | Alle producten" als schakelaar.
   - Shopify: de taal van het thema (window.CW_RS_LOCALE) wordt de paginataal, want de taalknoppen van de mockup zitten verborgen. */
(function () {
  const q = s => document.querySelector(s);
  const body = document.body, root = document.documentElement;

  // hoogte van de header meten (echte header: #cwh-wrap, nagebouwde: #cwhWrap)
  const hw = q('#cwh-wrap') || q('#cwhWrap');
  if (hw) {
    let lastH = 0;
    /* doorlopende pagina (html.cl-flow, Clean-laag, 11 okt): de kopbalk schuift weg (top van de vaste header-group, window.__cwHdrS px, dus de onderkant beweegt mee) en --hdr is de
       ingeklapte stand, dus zonder de aankondigingsbalk (.cwh-announce-shell). Zo meet dit nooit een tussenstand: de translate wordt
       teruggerekend, en een oude kopbalk die zelf krimpt geeft kopbalk min balk = dezelfde waarde. */
    const measure = () => {
      const flow = root.classList.contains('cl-flow'), sh = flow ? hw.querySelector('.cwh-announce-shell') : null;
      const h = Math.round(hw.getBoundingClientRect().bottom + (flow ? (window.__cwHdrS || 0) : 0) - (sh ? sh.offsetHeight : 0));
      if (h > 0 && h !== lastH) { lastH = h; root.style.setProperty('--hdr', h + 'px'); }
    };
    window.CW_HDR_MEASURE = () => { lastH = 0; measure(); };
    measure();
    if (window.ResizeObserver) new ResizeObserver(measure).observe(hw); else addEventListener('resize', measure);
    addEventListener('load', measure);
  }

  // categoriechips in de middenkolom: smal op desktop, dus scrollen met pijltjes, het muiswiel en vervaagde randen
  const cs = q('#catScroll');
  if (cs) {
    const cw = document.createElement('div'); cw.className = 'cwh-catwrap';
    cs.parentNode.insertBefore(cw, cs); cw.appendChild(cs);
    const arrow = dir => {
      const b = document.createElement('button'); b.type = 'button'; b.className = 'cwh-catarr cwh-catarr--' + dir; b.tabIndex = -1;
      b.setAttribute('aria-hidden', 'true');
      b.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><polyline points="' + (dir === 'l' ? '15 6 9 12 15 18' : '9 6 15 12 9 18') + '"/></svg>';
      b.addEventListener('click', () => cs.scrollBy({ left:(dir === 'l' ? -1 : 1) * Math.max(160, cs.clientWidth * .7), behavior:'smooth' }));
      cw.appendChild(b);
    };
    arrow('l'); arrow('r');
    const edges = () => {
      const max = cs.scrollWidth - cs.clientWidth;
      cs.classList.toggle('cwh-fl', cs.scrollLeft > 4); cs.classList.toggle('cwh-fr', cs.scrollLeft < max - 4);
    };
    cs.addEventListener('scroll', edges, { passive:true });
    cs.addEventListener('wheel', e => {
      if (Math.abs(e.deltaY) <= Math.abs(e.deltaX) || cs.scrollWidth <= cs.clientWidth) return;
      e.preventDefault(); cs.scrollLeft += e.deltaY;
    }, { passive:false });
    addEventListener('resize', edges);
    // renderCats (app.js) bouwt de chips opnieuw bij taal en voorkeuren: dan opnieuw meten (enkel lezen + klassen op cs zelf)
    new MutationObserver(() => requestAnimationFrame(edges)).observe(cs, { childList:true });
    if (window.ResizeObserver) new ResizeObserver(edges).observe(cs);
    edges();
  }

  // "Jouw feed | Alle producten" als Apple-schakelaar (eigenaar 6 okt): een losse pil (thumb) schuift met een veer naar de
  // gekozen knop i.p.v. dat elke knop zelf van kleur wisselt. Volgt aria-selected (setView in app.js), dus geen eigen klikken.
  const vs = q('.cats .viewseg');
  if (vs) {
    const sel = () => vs.querySelector('[aria-selected="true"]');
    const s0 = sel(); if (s0) vs.style.setProperty('--thumb-bg', getComputedStyle(s0).backgroundColor);
    const th = document.createElement('i'); th.className = 'cwh-thumb'; th.setAttribute('aria-hidden', 'true'); vs.insertBefore(th, vs.firstChild);
    vs.classList.add('cwh-sw');
    const place = anim => {
      const b = sel(); if (!b) return;
      if (!anim) th.style.transition = 'none';
      vs.style.setProperty('--tx', b.offsetLeft + 'px'); vs.style.setProperty('--tw', b.offsetWidth + 'px');
      if (!anim) { void th.offsetWidth; th.style.transition = ''; }
    };
    place(false);
    new MutationObserver(() => place(true)).observe(vs, { subtree:true, attributes:true, attributeFilter:['aria-selected'] });
    if (window.ResizeObserver) { const ro = new ResizeObserver(() => place(false)); vs.querySelectorAll('button').forEach(b => ro.observe(b)); }
    vs.addEventListener('pointerdown', () => vs.classList.add('cwh-press'));
    addEventListener('pointerup', () => vs.classList.remove('cwh-press'));
    addEventListener('pointercancel', () => vs.classList.remove('cwh-press'));
  }

  // Shopify: de taal van het thema (NL zonder voorvoegsel, /fr, /en) wordt de paginataal; de verborgen taalknop doet de rest
  const loc = String(window.CW_RS_LOCALE || '').slice(0, 2);
  if (loc === 'fr' || loc === 'en') {
    const go = () => setTimeout(() => { const b = q('.lang [data-lang="' + loc + '"]'); if (b && b.getAttribute('aria-pressed') !== 'true') b.click(); }, 0);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go();
  }

  /* --vv-b (15 okt, iOS 26 Safari): hoeveel het vaste blok (position:fixed, bottom:0) onder het zichtbare venster (visualViewport)
     uitsteekt. iOS 26 meldt daar soms een verschil (bv. 24 px na het toetsenbord, WebKit bug 297779); vaste onderbalken tellen het op
     via --ui-gap (style.css). Niet tijdens typen (toetsenbord), niet bij inzoomen, en nooit meer dan 160 px.
     Meten pas 150 ms na de laatste scroll- of resize-melding (de werkbalk klapt per frame in en uit), dan in een animatieframe, en enkel
     schrijven bij een verschil van 2 px of meer: elke wijziging van --vv-b herberekent de stijl van de hele pagina. */
  // vaste marge voor de zwevende werkbalk enkel in Safari op iOS 26 of hoger (niet Chrome, Firefox of Edge op iOS, geen oudere iOS)
  const ua = navigator.userAgent || '';
  const iosV = /(iPhone|iPod|iPad)/.test(ua) && !/(CriOS|FxiOS|EdgiOS|OPiOS)/.test(ua) && /Safari\//.test(ua) ? (ua.match(/Version\/(\d+)/) || [])[1] : 0;
  if (+iosV >= 26) root.classList.add('cw-ios26tb');
  const vv = window.visualViewport;
  if (vv) {
    const pr = document.createElement('div');
    pr.setAttribute('aria-hidden', 'true');
    pr.style.cssText = 'position:fixed;left:0;top:0;bottom:0;width:0;visibility:hidden;pointer-events:none';
    body.appendChild(pr);
    let lastB = 0, vraf = 0, vtm = 0;
    const vvRun = () => {
      vraf = 0;
      const a = document.activeElement, typing = !!a && (a.tagName === 'INPUT' || a.tagName === 'TEXTAREA' || a.isContentEditable);
      let d = Math.round(pr.getBoundingClientRect().bottom - (vv.offsetTop + vv.height));
      if (typing || vv.scale > 1.01 || !(d > 0) || d > 160) d = 0;
      if (Math.abs(d - lastB) >= 2) { lastB = d; root.style.setProperty('--vv-b', d + 'px'); }
    };
    const vvKick = () => { clearTimeout(vtm); vtm = setTimeout(() => { if (!vraf) vraf = requestAnimationFrame(vvRun); }, 150); };
    vv.addEventListener('resize', vvKick);
    vv.addEventListener('scroll', vvKick);
    addEventListener('resize', vvKick);
    addEventListener('orientationchange', vvKick);
    addEventListener('focusin', vvKick);
    addEventListener('focusout', () => setTimeout(vvKick, 350));
    vvKick();
  }

  body.classList.add('cwh-on');
})();

